import React, { Component } from "react";
import axios from "axios";
import { apiHost } from "../../api/apiClient";
import { setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";

class Location extends Component {
  constructor(props) {
    super(props);
    this.state = {
      locationData: `${this.props.lat},${this.props.lng}`,
      isLoading: true,
    };
  }
  async componentDidMount() {
    if (this.props.lat && this.props.lng && this.props.address === null) {
      this.GetLocationAddress(this.props.lat, this.props.lng);
    } else if (this.props.lat && this.props.lng && this.props.address) {
      this.setState({ locationData: this.props.address });
    } else {
      this.setState({ locationData: "Location data not available" });
    }
  }

  async componentDidUpdate(prevProps) {
    if (this.props.realTime === 1) {
      if (this.props.lat !== prevProps.lat || this.props.lng !== prevProps.lng) {
        this.GetLocationAddress();
      }
    }
  }

  GetLocationAddress = async () => {
    try {
      const response = await axios.get(`${apiHost}/api/Assets/GetLocationAddress?Latitude=${this.props.lat}&Longitude=${this.props.lng}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      if (response.status == "200") {
        this.setState({ locationData: response.data });
      }
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      console.log(`😱 Axios request failed: ${e}`);
    }
  };
  render() {
    if (!this.props.lat || !this.props.lng) return <em className="text-muted">Location data not available</em>;
    return (
      <span>
        {this.state.locationData}
        <a
          href={`https://www.google.com/maps/search/?api=1&query=${this.props.lat},${this.props.lng}`}
          title="View on Google Maps"
          target="_blank"
          rel="noreferrer"
        >
          <i className="fa fa-map-marker" aria-hidden="true"></i> Map
        </a>
      </span>
    );
  }
}
const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(Location);
